import { useAccessibility } from "../../Store/contexts/AccessibilityContext";

function TrashIcon() {

    const accessibility = useAccessibility();

    return (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.2183 3.125H13.9761L12.6479 0.9375C12.3354 0.390625 11.7104 0 11.0464 0H7.10107C6.43701 0 5.81201 0.390625 5.49951 0.9375L4.17139 3.125H0.968262C0.616699 3.125 0.343262 3.4375 0.343262 3.75V4.375C0.343262 4.72656 0.616699 5 0.968262 5H1.59326L2.41357 18.2422C2.45264 19.2578 3.27295 20 4.28857 20H13.8589C14.8745 20 15.6948 19.2578 15.7339 18.2422L16.5933 5H17.2183C17.5308 5 17.8433 4.72656 17.8433 4.375V3.75C17.8433 3.4375 17.5308 3.125 17.2183 3.125ZM7.10107 1.875H11.0464L11.7886 3.125H6.35889L7.10107 1.875ZM13.8589 18.125H4.28857L3.46826 5H14.6792L13.8589 18.125Z" fill={accessibility.contrastMode ? accessibility.contrastColor : '#00995D'}/>
        </svg>
    )
}

export default TrashIcon;